<template>
  <div class="componentsCtn" >
    <div class="topCtn" >
      <div style="height: 40px;line-height: 40px;width: 1280px; margin-right: auto;margin-left: auto;padding-left: 3px">
        <span @click="$router.push('/')" style="cursor:pointer">首页/</span><span style="color:#3A3A3A;">个人中心</span>
      </div>
    </div>
    <div class="mainCtn" >

      <div style="width:100%;height: auto;display: flex;justify-content: space-between">
        <div class="menuPanel">
          <div @click="goImgSparate()" :class="['menuItem','']" style="margin-top: 7px;">
            <div class="menuItem_png">
              <img src="../assets/userCenter/我的影像.png" height="16" width="18" align="baseline"
                   style="margin-bottom: -2px"/>
            </div>
            我的影像
          </div>
          <div @click="chooseItem(5)" :class="['menuItem',,selectedItem==5 ? 'goldMode':'']" style="margin-top: 7px;">
            <div class="menuItem_png">
              <img v-if="selectedItem==5" src="../assets/userCenter/我的矢量库_选中.png" height="16" width="18"
                   align="baseline" style="margin-bottom: -2px"/>
              <img v-else src="../assets/userCenter/我的矢量库_默认.png" height="16" width="18" align="baseline"
                   style="margin-bottom: -2px"/>
            </div>
            我的矢量
          </div>
          <div @click="chooseItem(1)" :class="['menuItem',,selectedItem==1 ? 'goldMode':'']">
            <div class="menuItem_png">
              <img v-if="selectedItem==1" src="../assets/userCenter/我的项目-选中.png" height="16" width="18"
                   align="baseline" style="margin-bottom: -2px"/>
              <img v-else src="../assets/userCenter/我的项目-未选中.png" height="16" width="18" align="baseline"
                   style="margin-bottom: -2px"/>
            </div>
            我的项目
          </div>
          <div @click="chooseItem(2)" :class="['menuItem',,selectedItem==2 ? 'goldMode':'']">
            <div class="menuItem_png">
              <img v-if="selectedItem==2" src="../assets/userCenter/我的任务-选中.png" style="margin-bottom: -2px;"
                   height="16" width="16"/>
              <img v-else src="../assets/userCenter/我的任务-未选中.png" style="margin-bottom: -2px;" height="16"
                   width="16"/>
            </div>
            我的任务
          </div>
          <div @click="chooseItem(3)" :class="['menuItem',,selectedItem==3 ? 'goldMode':'']">
            <div class="menuItem_png">
              <img v-if="selectedItem==3" src="../assets/userCenter/我的团队-选中.png" style="margin-bottom: -2px;"
                   height="16" width="16"/>
              <img v-else src="../assets/userCenter/我的团队-未选中.png" style="margin-bottom: -2px;" height="16"
                   width="16"/>
            </div>
            我的团队
          </div>
          <div @click="chooseItem(4)" :class="['menuItem',,selectedItem==4 ? 'goldMode':'']" style="position:relative">
            <div class="menuItem_png">
              <img v-if="selectedItem==4" src="../assets/userCenter/我的消息-选中.png" height="16" width="18"
                   align="baseline" style="margin-bottom: -2px"/>
              <img v-else src="../assets/userCenter/我的消息-未选中.png" height="16" width="18" align="baseline"
                   style="margin-bottom: -2px"/>
            </div>
            我的消息
            <div v-if="unreadCount_center>0" class="messageTip" style="top:17px;right:17px;">
            </div>
          </div>

        </div>
        <div class="contentCtn">
          <myProject v-if="selectedItem==1"></myProject>
          <myTask v-if="selectedItem==2"></myTask>
          <myTeam v-if="selectedItem==3"></myTeam>
          <myMessage v-if="selectedItem==4"></myMessage>
          <my-vector-library v-if="selectedItem==5"></my-vector-library>

        </div>
      </div>
    </div>
  </div>


</template>

<script>
import myProject from "./userCenter/myProject.vue"
import myTask from "./userCenter/myTask.vue"
import myTeam from "@views/userCenter/myTeam.vue";
import myMessage from "@views/userCenter/myMessage.vue";
import myVectorLibrary from "@views/userCenter/myVectorLibrary.vue";
import {rootUrl} from "@/globalConfig";

export default {
  name: "universityUserCenter",
  components: {
    myProject, myTask, myTeam, myMessage,myVectorLibrary
  },
  data() {
    return {
      selectedItem: 5,
      unreadCount_center:0,

    }
  },
  methods: {
    jumpWithPermission(type,path,fromUrl){
      //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
      //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
      let loginUserId=localStorage.getItem('userId');//是否已登录
      let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
      if(type=='可游客'){
        if(fromUrl){
          window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
        }
        else {
          window.open(rootUrl+path,"_self")
        }
      }else if(type=='仅登录'){
        //已登录
        if(loginUserId){
          if(fromUrl){
            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+path,"_self")
          }
        }
        //未登录
        else {
          if(fromUrl){
            window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+'/Login',"_self")
          }
        }
      }else if(type=='仅实名'){
        //已登录
        if(loginUserId){
          //已实名
          if(authentication=='0'){
            if(fromUrl){
              window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+path,"_self")
            }
          }
          //未实名
          else {
            window.open(rootUrl+'/Authentication',"_self")
          }

        }
        //未登录
        else {
          if(fromUrl){
            window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+'/Login',"_self")
          }
        }
      }
    },
    getKey() {
      return localStorage.getItem("token");
    },
    chooseItem: function (data) {
      this.selectedItem = data;
      this.$router.push({path: 'userCenter', query: {'type': data}});
    },
    getUnreadCount:function () {
      this.axios.post("/tilesapi/tiles/message/queryMessageCount","", {
        headers: {
          Authorization: "Bearer " + this.getKey(),
        },
      }).then((response) => {
        console.log('我的消息未读数量_usercenter')
        console.log(response)
        if(response.status==200){
          this.unreadCount_center=response.data.data;
          console.log(response.data)
        }
      })
    },
    goImgSparate(){
         this.$router.push("/imageSegmentation")

    },

  },
  mounted() {
    console.log('router参数')
    console.log(this.$route.query)
    let itemType = this.$route.query.type;
    if (itemType) {
      this.selectedItem = itemType
    }
    if(this.$store.state.user.logined == false){
      this.$router.push("/Login");
    }
    this.getUnreadCount();

  }
}
</script>

<style scoped lang="scss">
@import "../custom.scss";
.messageTip{
  position:absolute;
  width: 6px;
  height: 6px;
  background: #FF4040;
  border-radius: 3px;
}
.contentCtn {
  width: 1105px;
  min-height: 660px;
  background: #F5F5F6;
  border-radius: 16px;
}

.menuItem_png {
  display: inline-block;
  width: 18px;
  height: 16px;
  margin-left: 22px;
  margin-right: 10px;
}

.menuItem {
  margin-top: 3px;
  width: 147px;
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  font-weight: bold;
  margin-left: auto;
  margin-right: auto;
  border-radius: 8px;
  cursor: pointer;
}

.goldMode {
  color: #1f91f5;
  background: $background-color-blue;
}

.menuItem:hover {
  background: $background-color-blue;
}

.menuPanel {
  width: 160px;
  height: 331px;
  background: #F5F5F6;
  border-radius: 16px;
}

.topCtn {
  width: 100%;
  height: 45px;
  line-height: 45px;
  margin-top: 76px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 102px;
  background: #F5F5F6 ;
  margin-bottom: 50px;
}

.mainCtn {
  position: relative;
  width: 1280px;
  min-height: 960px;
  margin-right: auto;
  margin-left: auto;
  background: #ffffff;
}

.componentsCtn {
  width: 100%;
  min-height: 960px;
  background: #ffffff;

}

</style>
